export default __webpack_public_path__ + "static/media/2026_Sun_and_Ke_2026_JAnimalEcol.447b4ddc.pdf";